<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <!--培训项目-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">报考专业</label>
                            <div class="col-sm-8">
								<BootstrapCombobox :data="pcList" text-field="mc" value-field="id" v-model="query.pcId" placeholder="-报考专业筛选-" :formatOption="(item)=>(item.xmbh+'-'+item.mc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--课程-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">课程</label>
                            <div class="col-sm-8">
                                <BootstrapCombobox :data="kcList" value-field="id" text-field="kcmc" v-model="query.kcId" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--试卷名称-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">试卷名称</label>
                            <div class="col-sm-8">
                                <input type="text" name="sjmcWord" v-model="query.sjmcWord" v-validate="{required:true,max:50}" class="form-control" data-vv-as="试卷名称"  placeholder=""/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">批改状态</label>
                            <div class="col-sm-8">
                                <select name="sjzt" v-model="query.djzt" class="form-control">
                                    <option value="">-请选择-</option>
                                    <option v-for="item in djztList" :key="item.value" :value="item.value">
                                        {{item.text}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">考生关键字</label>
                            <div class="col-sm-8">
                                <input type="text" name="ksWord" v-model="query.ksWord" v-validate="{required:true,max:50}" class="form-control" data-vv-as="考生关键字"  placeholder=""/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="pull-right">
                            <button   @click="search()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>搜索</button>
                            <button   @click="dc()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-download" aria-hidden="true"></i>导出</button>
                            <button   @click="plsc()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-remove" aria-hidden="true"></i>批量删除</button>
                            <button   @click="plsx()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-database" aria-hidden="true"></i>批量生效</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
		<ExamYzZhuapai ref="ExamYzZhuapai"></ExamYzZhuapai>
    </div>
</template>
<script>

    /**
     * 综合测验记录  已做记录
     */

    import tableMixin from '@/mixins/table.js';  //表格
    import ExamYzZhuapai from './ExamYzZhuapai.vue';  //抓拍详情
    import qs from "qs";
    export default {
        mixins: [tableMixin],
        name:"ExamYzRecordList",
        components :{
			ExamYzZhuapai
        },
        data:function(){
            return {
                js: this.$store.state.user.js,
                pcList:[],
                kcList:[],
                qyList:[],
                djztList:[],
                query:{
                    sjId:this.$route.query.id,
                    pcId:'',
                    kcId:'',
                    qyId:'', //学员单位
                    sjmcWord:'',
                    ksWord:'',
                    djzt:''

                },
                columns: [
                    {
                        field: 'state',
                        checkbox: true
                    },
                    {
                        field: 'pcmc',
                        title: '报考专业',
                        formatter: (value, row) => {
                            return row.xmbh + '-' + value;
                        }
                    },
                    {
                        field: 'kcmc',
                        title: '课程'
                    },
                    {
                        field: 'sjmc',
                        title: '试卷名称',
                    },
                    {
                        field: 'xm',
                        title: '姓名'
                    },
					{
					    field: 'sfzh',
					    title: '身份证号'
					},
					// {
					//     field: 'jgmc',
					//     title: '学员单位'
					// },
                    {
                        field: 'bjmc',
                        title: '班级'
                    },
                    {
                        field: 'kssj',
                        title: '考试时间',
                        formatter: (value, row) => {
                            if (row.kssj && row.jssj) {
                                //后台返回的有秒  截取0到16
                                return row.kssj.substring(0, 16) + "<br />" + row.jssj.substring(0, 16);
                            }
                            return '';
                        }
                    },
                    {
                        field: 'kshs',
                        title: '耗时(分钟)'
                    },
                    {
                        field: 'djzt',
                        title: '批改状态',
                        formatter: (value) => {
                            return value=='WJJ'?'未交卷':
                                value=='YJJDPG'?'已交卷待批改':
                                    value=='YZDPG'?'已自动批改':
                                        value=='YSDPG'?'已手动批改':
                                            value=='YSX'?'已生效':'批改失败';
                        }
                    },
                    {
                        field: 'fs',
                        title: '得分'
                    },
                    {
                        field: 'actions',
                        title: '操作',
						align:'center',
                        formatter: (value, row) => {
                            let str='<div class="operation_column">'
                            if (row.djzt!='YSDPG') {
                                str += '<a @click="pysj(row)">批阅试卷</a> | '
                            }
                            if(row.djzt != 'WJJ' && row.djzt!='YSX'){
                              str += '<a @click="sx(row)">生效</a> | ' +
                                   '<a  @click="cxpg(row)">重新批改</a> | ' +
                                   '<a  @click="del(row)">删除</a> | '
                            }
                            str += '<a  @click="zp(row)">抓拍照片详情</a></div>';
                            return this.vueFormatter({
                                template:str,
                                data: {row},
                                methods: {
                                    del: this.del,
                                    pysj: this.pysj,
                                    sx: this.sx,
                                    cxpg: this.cxpg,
                                    zp: this.zp
                                }
                            })
                        }
                    }
                ]
            }
        },
      mounted(){
      	this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
      	this.load();
      },
      beforeRouteUpdate(to, from, next){
		 this.query = Object.assign(this.query,{current:1,size:10},to.query);
      	this.load();
      	next();
      	let sjId = this.$route.query.id
          if (sjId) {
              this.$store.commit('setShowReturnBackBtn',true);
          }
      },
        created:function(){
            this.djztList = [{value: 'WJJ', text: '未交卷'}, {value: 'YJJDPG', text: '已交卷待批改'}, {value: 'YZDPG', text: '已自动批改'}, {value: 'YSDPG', text: '已手动批改'}, {value: 'YSX', text: '已生效'}, {value: 'PGSB', text: '批改失败'}];//答卷状态
            this.getpcList();
            // this.getqyList();
            this.$store.commit('setBreadcrumb', [{name: '自学考试'}, {name: '日常练习管理'}, {name: '已做记录'}]);
            let sjId = this.$route.query.id
            if (sjId) {
                this.$store.commit('setShowReturnBackBtn',true);
            }
        },
        watch: {  //课程列表联动
            "query.pcId": function (value) {
				this.query.kcId = '';
                if (value) {
                    this.$http.post("/htgl/biz/zypx/zhcyyzjl/hqkc", {pcId: value}).then(res => {
                        this.kcList = res.data;
                    });
                }
                else {
                    this.kcList = [];
                }
            }
        },
        methods: {
            //抓拍照片详情
            zp:function(row){
				this.$refs.ExamYzZhuapai.open({  ksId: row.ksyh_id,
                            ksjlId: row.id,});
            },
            //培训项目列表
            getpcList: function () {
                this.$http.post('/htgl/biz/zypx/zhcyyzjl/hqpc').then(res => {
                    this.pcList = res.data;
                });
            },
            //获取学员单位列表
            // getqyList: function () {//hqByQy
            //     this.$http.post('/htgl/biz/zypx/zhcyyzjl/hqByQy').then(res => {
            //         if(res.data){
            //             this.qyList = res.data;
            //         }
            //     });
            // },
            dc:function(){//文件导出下载 标准写法
                this.$confirm('即将按照查询条件导出,确定继续吗？',()=>{
                    window.open('/htgl/biz/zypx/zhcyyzjl/dc?'+qs.stringify(this.query));
                });
            },
            //生效
            sx:function(row){
                let ids = [];
                if(row){
                    ids.push(row.id);
                    ids = ids.join(",");
                };
                this.$confirm('确定执行此操作吗',()=>{
                    this.$http.post("/htgl/biz/zypx/zhcyyzjl/sx",{ids:ids}).then((res)=>{
                        if(res.data==true){
                            this.$success('操作成功',()=>{
                                this.load();
                            })
                        }
                    })
                });
            },
            //批量生效
            plsx:function(){
                let ids = [];
                let selections = this.$refs.table.getSelections();
                ids = selections.map(x => {
                    return x.id
                });
                if (ids && ids.length > 0) {
                    ids = ids.join(",");
                } else {
                    this.$error("请选择一条数据");
                    return;
                };
                //确定要生效选中记录的分数吗（生效之后就不能再批改了）？
                this.$confirm('确定执行此操作吗',()=>{
                    this.$http.post("/htgl/biz/zypx/zhcyyzjl/sx",{ids:ids}).then((res)=>{
                        if(res.data==true){
                            this.$success('操作成功',()=>{
                                this.load();
                            })
                        }
                    })
                });
            },
            //删除
            del:function(row){
                let ids = [];
                if(row){
                    ids.push(row.id);
                    ids = ids.join(",");
                };
                this.$confirm('确定执行此操作吗',()=>{
                    this.$http.post("/htgl/biz/zypx/zhcyyzjl/sc",{ids:ids}).then((res)=>{
                        if(res.data==true){
                            this.$success('操作成功',()=>{
                                this.load();
                            })
                        }
                    })
                });
            },
            //批量删除
            plsc: function () {
                let ids = [];
                let selections = this.$refs.table.getSelections();
                ids = selections.map(x => {
                    return x.id
                });
                if (ids && ids.length > 0) {
                    ids = ids.join(",");
                }
                else {
                    this.$error("请选择一条数据");
                    return;
                }
                this.$confirm('确定执行此操作吗',()=>{
                    this.$http.post("/htgl/biz/zypx/zhcyyzjl/sc",{ids:ids}).then((res)=>{
                        if(res.data==true){
                            this.$success('操作成功',()=>{
                                this.load();
                            })
                        }
                    })
                });
            },
            //重新批改
            cxpg:function(row){
                this.$confirm('即将进行试卷批改，该操作可能影响考生成绩，且操作不可逆，如无特别需要不建议进行此操作。请谨慎操作',()=>{
                    this.$http.post("/htgl/biz/zypx/zhcyyzjl/cxpy",{id:row.id,sjId:row.sj_id}).then((res)=>{
                        if(res.data==true){
                            this.$success('操作成功',()=>{
                                this.load();
                            })
                        }
                    })
                });
            },
            pysj:function(row){
                this.$router.push({name: 'ExamYzPysj',
                    query: {sjId: row.sj_id, ksjlId: row.id, ksyhId: row.ksyh_id,xm:row.xm,sfzh:row.sfzh,fs:row.fs, djzt: row.djzt}
                })
            },
            search: function () {
               //将数据表格的页码以及每一页展示的数据重置为1，10
               let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
               this.$router.push({name:this.$route.name,query:query});
            },
            load:function(pageNumber,pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/biz/zypx/zhcyyzjl/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            pageChange:function(pageNumber, pageSize){
               let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
               this.$router.push({name:this.$route.name,query:query});
            }
        }
    }
</script>
<style scoped>
</style>
